/**
 * firebase.ts
 *
 * Initialises the Firebase client SDK when VITE_FIREBASE_API_KEY is set.
 * When not set (DEMO_MODE local dev), exports null-safe stubs so the rest
 * of the codebase compiles without changes.
 *
 * Check IS_FIREBASE_ENABLED before calling any Firebase method.
 */

import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'

export const IS_FIREBASE_ENABLED = !!(
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_PROJECT_ID
)

let _app: FirebaseApp | null = null
let _auth: Auth | null = null

if (IS_FIREBASE_ENABLED) {
  _app = initializeApp({
    apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId:             import.meta.env.VITE_FIREBASE_APP_ID,
  })
  _auth = getAuth(_app)
}

export const app  = _app
export const auth = _auth
